export enum ResultType {
  AUDIO = 'AUDIO',
  CHALLENGE = 'CHALLENGE',
  INSIGHT = 'INSIGHT',
  MULTIPLE_CHOICE = 'MULTIPLE_CHOICE',
  OPEN_TEXT = 'OPEN_TEXT',
  SCALE = 'SCALE',
  TEXT = 'TEXT',
}

export interface StepResult {
  header: string
  response?: any
  stepData?: any
  type: ResultType
}

export interface ResultData {
  id: number
  results: StepResult[]
}
